export const StartConfig = {
    HIGH_INTENT: true,
    SESSION_TIMEOUT_MS: 7 * 60 * 1000, // 7 minutes
    FAKE_CONNECT_DELAY: 700, // 0.7 seconds
};
